import { z } from "zod";
export { FLEET_VIOLATION_ACTION_LABELS, FLEET_VIOLATION_ACTIONS, FLEET_VIOLATION_CODES, FLEET_VIOLATION_LABELS, fleetPolicySchema, fleetTimeWindowSchema, fleetUsageSchema, fleetViolationActionSchema, } from "@station/pricing-engine";
export const FLEET_BILLING_CYCLES = ["WEEKLY", "SEMI_MONTHLY", "MONTHLY"];
export const fleetBillingCycleSchema = z.enum(FLEET_BILLING_CYCLES);
export const FLEET_BILLING_CYCLE_LABELS = {
    WEEKLY: "Haftalık",
    SEMI_MONTHLY: "15 günlük",
    MONTHLY: "Aylık",
};
export const FLEET_ACCOUNT_STATUSES = ["ACTIVE", "SUSPENDED"];
export const fleetAccountStatusSchema = z.enum(FLEET_ACCOUNT_STATUSES);
export const VEHICLE_TAG_KINDS = ["TAG", "CARD"];
export const vehicleTagKindSchema = z.enum(VEHICLE_TAG_KINDS);
export const VEHICLE_TAG_KIND_LABELS = {
    TAG: "TTS etiketi (depo halkası / RFID)",
    CARD: "Taşıt kartı",
};
export const VEHICLE_TAG_STATUSES = ["ACTIVE", "LOST", "INACTIVE"];
export const vehicleTagStatusSchema = z.enum(VEHICLE_TAG_STATUSES);
export const FLEET_BILLING_RUN_STATUSES = ["DRAFT", "ISSUED", "CANCELLED"];
export const fleetBillingRunStatusSchema = z.enum(FLEET_BILLING_RUN_STATUSES);
export const FLEET_BILLING_RUN_STATUS_LABELS = {
    DRAFT: "Taslak",
    ISSUED: "Faturalandı",
    CANCELLED: "İptal",
};
export const FLEET_VEHICLE_REQUEST_STATUSES = ["PENDING", "APPROVED", "REJECTED"];
export const fleetVehicleRequestStatusSchema = z.enum(FLEET_VEHICLE_REQUEST_STATUSES);
//# sourceMappingURL=enums.js.map